// Auth result model
export class AuthResult {
  constructor({
    isSuccess = false,
    message = null,
    error = null,
    errorCode = null,
    user = null,
    token = null,
  }) {
    this.isSuccess = isSuccess;
    this.message = message;
    this.error = error;
    this.errorCode = errorCode;
    this.user = user;
    this.token = token;
  }
}
